'use client'

import { Button } from '@algoacademy/design-system/web/actions/Button'
import type { MouseEvent } from 'react'

function handleClick(event: MouseEvent<HTMLButtonElement>) {
  event.preventDefault()

  // TODO: Replace querySelector with a ref-based scroll
  const contactForm = document.querySelector('#contact-form')

  if (contactForm) {
    contactForm.scrollIntoView({ behavior: 'smooth' })
  }
}

export function ScrollToContactButton() {
  return (
    <Button marketing onClick={handleClick}>
      Napisz do mnie
    </Button>
  )
}
